import { useNavigate, useParams } from 'react-router-dom';
import ProjectDetailsView from './ProjectDetailsView';

const ProjectsView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const projectId = Number(id);

    return (
        <ProjectDetailsView
            projectId={projectId}
            onEdit={() => navigate(`/projects/edit/${projectId}`)}
        />
    );
}

export default ProjectsView
